import React from "react";
import { Box, Button } from "@material-ui/core";
import { ImageSearch } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import ReferenceImageThumbnail from "./ReferenceImageThumbnail";
import { blobToDataUrl } from "./imageUtils";

type ImageUploadTabProps = {
  uploadedImage: string | null;
  onImageUploaded: (dataUrl: string) => void;
};

const ImageUploadTab: React.FC<ImageUploadTabProps> = ({ uploadedImage, onImageUploaded }) => {
  const { t } = useTranslation();

  const handleImageUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const dataUrl = await blobToDataUrl(file);
      onImageUploaded(dataUrl);
    }
  };

  return (
    <>
      {uploadedImage && (
        <Box display="flex" justifyContent="center" mb={2}>
          <ReferenceImageThumbnail imageUrl={uploadedImage} />
        </Box>
      )}
      <input
        id="reference-image-upload"
        type="file"
        accept="image/*"
        onChange={handleImageUpload}
        style={{ display: "none" }}
      />
      <label htmlFor="reference-image-upload">
        <Button variant="outlined" component="span" fullWidth startIcon={<ImageSearch />}>
          {t("imageGenerator.uploadReference")}
        </Button>
      </label>
    </>
  );
};

export default ImageUploadTab;
